import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Testimonial {
    rating: number;
    text: string;
    author: string;
}

@Component({
    selector: 'app-testimonials-section',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './testimonials-section.component.html',
    styleUrls: ['./testimonials-section.component.scss']
})
export class TestimonialsSectionComponent {

    testimonials: Testimonial[] = [
        {
            rating: 5,
            text: 'Stumbled onto Dimers, joined Pro, then Platinum—what a blessing! I’m up since Week 3. Huge kudos to the Platinum crew. Feels like I’m beating vets after just one month. These AI picks are unreal—75% is unheard of!',
            author: 'Pick Master',
        },
        {
            rating: 5,
            text: 'This is real. I joined for week 4. I was conservative at first wanting verification of the concept. PLATINUM ran 70% for the year. It was plus money 12 of 14 weeks. I will absolutely be with them again next year.',
            author: 'Rich Ford',
        },
        {
            rating: 5,
            text: 'Dimers Platinum gives you everything you need to focus on one sport and find real value to boost your ROI.. From cheat sheets to elite CFB 1st Quarter picks, it takes your wagering to the next level.',
            author: 'Scott Carpenter',
        },
    ];
    createLoopArray(length: number): Array<any> {
        return new Array(length);
    }
}
